/* eslint-disable */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React from 'react';
import HTMLFlipBook from 'react-pageflip';
import appstate, { getLocaledString } from '../../appstate';
import { ArrowDownComponent } from '../arrowDownComponent';

interface Page {
	front: {
		title: string;
		body: string;
		source: string;
	};
	back: {
		title: string;
		body: string;
		source: string;
	};
}

const BookyDooky = (props: {
	children: React.ReactNode | React.ReactNode[];
}) => {
	const [currentPage, setCurrentPage] = React.useState(0);

	return (
		<div
			className={'w-full'}
			style={{
				height:
					appstate.currentLanguage() === 'slSI' ? '475px' : '530px',
			}}
		>
			<div
				className={
					'absolute top-0 left-0 w-1/2 h-full bg-white/50 flex justify-center items-center opacity-0 hover:opacity-70 transition-all'
				}
				onClick={() => {
					setCurrentPage(Math.max(currentPage - 1, 0));
				}}
			>
				<div className={'transform rotate-0 w-16 h-16 opacity-10'}>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className={'transform rotate-0'}
					>
						<path
							d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
							fill="currentColor"
						/>
					</svg>
				</div>
			</div>
			<div
				className={
					'absolute top-0 right-0 w-1/2 h-full bg-white/50 flex justify-center items-center opacity-0 hover:opacity-70 transition-all'
				}
				onClick={() => {
					setCurrentPage(
						Math.min(currentPage + 1, props.children.length - 1),
					);
				}}
			>
				<div className={'w-16 h-16 opacity-10'}>
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className={'transform rotate-180'}
					>
						<path
							d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
							fill="currentColor"
						/>
					</svg>
				</div>
			</div>
			{props.children.map((child, index) => {
				return (
					<div
						className={`h-full select-none pointer-events-none ${
							index !== currentPage
								? `absolute left-0 top-0 transform opacity-0 ${
										index < currentPage
											? '-translate-x-full'
											: 'translate-x-full'
								  }`
								: ''
						} transition-all`}
						key={index}
					>
						{child}
					</div>
				);
			})}
		</div>
	);
};

export default function FlipComponent() {
	const sloPages: Page[] = [
		{
			front: {
				title: '',
				body: '',
				source: '',
			},
			back: {
				title: 'USKLAJEVANJE POKLICNEGA IN ZASEBNEGA ŽIVLJENJA',
				body: 'angleški izraz: work-life balance, tudi reconciliation of work, family and private life\nKrajša definicija: Usklajevanje zasebnega in poklicnega življenja označuje proces doseganja ravnotežja ne zgolj v oziru do gospodinjskih obveznosti, temveč tudi drugih obveznosti, povezanih z vsakodnevnim življenjem.\nkrajša definicija: Poklicne obveznosti bi morale biti dovolj fleksibilne, da bi omogočile delojemalcem vseh bioloških in družbenih spolov, da postanejo del vseživljenjskega učenja in drugih aktivnosti, ki omogočajo njihov profesionalni in osebnostni razvoj. Ključni izziv usklajevanja poklicnega in zasebnega življenja je v kariernih priložnostih, vseživljenjskem učenju in profesionalnem razvoju aktivnosti, ki so razumljene kot sekundarnega pomena pri promociji enakega deleža odgovornosti med spoloma.\n',
				source: 'MOD (2007), EIGE (2021).',
			},
		},
		{
			front: {
				title: 'DVOJNO BREME',
				body: 'angleški izraz: double burden\nkrajša definicija: Dvojno breme (včasih tudi dvojna izmena ali dvojni dan) označuje delovno obveznost posameznika_ce, ki je sicer v delovnem razmerju in za to prejema plačilo, ampak je prav tako odgovoren_na za delo, ki ne prinaša neposrednega plačila ali druge oblike plačila. Navadno gre bodisi za gospodinjsko bodisi za skrbstveno delo.\n',
				source: 'De Ferranti (2004), Chesters (2012).',
			},
			back: {
				title: 'OČETOVSKI DOPUST',
				body: 'angleški izraz: paternity leave\nkrajša definicija: Očetovski dopust je namenjen moškim s ciljem skrbstvenega dela z otrokom. Očetovski dopust v Sloveniji ni prenosljiv na drugo osebo in traja 30 dni. Ta se lahko podaljša za 10 dni v primeru rojstva dvojčkov in za 20 dni v primeru trojčkov. Za razliko od materinskega dopusta, očetovski dopust ni nujno v celoti strnjen, ampak se lahko koristi v dveh kosih, pri čemer mora prvi del trajati najmanj 15 dni v obdobju od rojstva otroka do najpozneje enega meseca po poteku starševskega dopusta ali dodatka.\n',
				source: 'Pravozavse (2022).',
			},
		},
		{
			front: {
				title: 'NA ENAKOSTI SPOLOV TEMELJEČA ORGANIZACIJSKA KULTURA',
				body: 'angleški izraz: gender-inclusive organisational culture\nkrajša definicija: Pri na enakosti spolov temelječi organizacijski kulturi gre za to, da je celostni in korporativni sistem vrednot, norm, prepričanj, stališč in načinov izvajanja procesov v podjetju zasnovan na način, da upošteva vidike načela enakosti med spoloma.\n',
				source: 'Ferland (2022).',
			},
			back: {
				title: 'SPOLNI STEREOTIP',
				body: 'angleški izraz: gender stereotype\nkrajša definicija: Spolni stereotipi so posplošene značilnosti, vedénja, sposobnosti in interesi, opredeljeni le na podlagi spola; so odraz dojemanja moških in žensk, razlik med njimi in njihovih družbenih vlog. Ustvarjajo nerealno in nepravično predstavo o moških in ženskah. V resničnem življenju tem opisom ne ustrezajo ne vsi moški ne vse ženske.\n',
				source: 'Časoris (2018).',
			},
		},
		{
			front: {
				title: 'ENAKOST MED SPOLOMA',
				body: 'angleški izraz: gender equality\nkrajša definicija: enake pravice in dolžnosti žensk, moških, deklic in dečkov\nSplošno o enakosti med spoloma: Enakost ne pomeni, da so moški in ženske enaki, temveč da posedujejo enake pravice, dolžnosti in priložnosti, ki niso odvisne od biološkega spola, v katerega se rodijo. Enakost med spoloma pomeni, da so tako interesi kot potrebe in prioritete moških in žensk vzeti v zakup na način, da se pripozna raznolikost različnih skupin moških in žensk. Enakost med spoloma ni zgolj ženski izziv, temveč je za doseganje le-te potreben poln angažma moških, Enakost med moškimi in ženskami je torej razumljen tako kot temeljna človekova pravica kot predpogoj, predvsem pa indikator trajnostnega, na posamezniku temelječega (people-centered) razvoja.',
				source: 'EIGE (2021), UN Women (2021).',
			},
			back: {
				title: 'DELITEV GOSPODINJSKIH OPRAVIL',
				body: 'angleški izraz: domestic division of labour\nkrajša definicija: Delitev skrbstvenih in gospodinjskih opravil med moškim in žensko.\n',
				source: 'EIGE (EIGE, 2021)',
			},
		},
		{
			front: {
				title: 'ENAKE MOŽNOSTI MOŠKIH IN ŽENSK',
				body: 'angleški izraz: equal opportunities for women and men\nkrajša definicija: Odsotnost vseh ovir za ekonomsko, politično in družbeno participacijo na podlagi biološkega ali družbenega spola.\nsplošno o enakih možnostih žensk in moških: Ovire za polno participacijo so večkrat posredne, težko merljive in se ohranjajo kot del širše strukture in družbenih predstav. Načelo enakih možnosti je eden izmed osrednjih ciljev enakosti spolov, ki temelji na predpostavki o širokem naboru strategij, ukrepov in dejanj, ki so predpogoj za naslavljanje globoko zakoreninjenih neenakosti.\n',
				source: 'EIGE (2021).',
			},
			back: {
				title: 'DRUŽINSKE OBVEZNOSTI',
				body: 'angleški izraz: familiy responsibilities\nkrajša definicija: Družinske obveznosti razumemo kot bodisi skrb bodisi podporo otroku ali drugemu družinskemu članu, ki ne more neodvisno opravljati vsakodnevnih obveznosti, in potrebuje stalen nadzor oziroma pomoč.\nsplošno o družinskih obveznostih: Ženske še naprej prevzemajo neproporcionalni delež bremena, ko pride do vprašanje vzgoje otroka, ali pa skrbi za druge družinske člane. To neposredno vpliva na njihovo zaposlitev oziroma zaposlitvene možnosti. Prav tako takšne obveznosti onemogočajo njihov vstop, participacijo ali pa krepitev lastnih zmogljivosti v javnem, političnem ali kulturnem življenju.\n',
				source: 'EIGE (2021).',
			},
		},
		{
			front: {
				title: 'VKLJUČEVANJE VIDIKA SPOLA',
				body: 'angleški izraz: gender mainstreaming\nkrajša definicija: Vključevanje vidika spola se nanaša na sistematično vključevanje razlik med pogoji, situacijami in potrebami moških in žensk v vse vidike javnih politik in dejanj.\nsplošno o vključevanju vidika spola: Vključevanje vidika spola je (re)organizacija, izboljšanje, razvoj in evalvacija političnih procesov na način, da so vse spolne perspektive vključene v vse javne politike na vseh ravneh in nivojih s strani akterjev, ki so navadno vključeni v proces oblikovanja javnih politik.\n',
				source: 'UNSD (2021), EIGE (2021).',
			},
			back: {
				title: 'SPOLNE NORME',
				body: 'angleški izraz: gender norms\nkrajša definicija: Spolne norme so ideje o tem, kako bi se morale ženske in moški obnašati. Te ideje so ponotranjene relativno zgodaj v otroštvu, in postajajo del splošnega življenjskega cikla socializacije in stereotipizacije.\n',
				source: 'UNSD (2021), EIGE (2021).',
			},
		},
		{
			front: {
				title: 'SPOLNA SLEPOTA',
				body: 'angleški izraz: gender blindness\nkrajša definicija: Spolna slepota označuje nezmožnost prepoznavanja, da so spolne vloge in obveznosti moških in žensk v naprej predpisane, in da so odvisne od specifičnega kulturnega, družbenega, ekonomskega in političnega konteksta.\nsplošno o spolni slepoti: Projekti, ki se ukvarjajo s spolno slepoto, ne vzamejo v zakup različne vloge in različne potrebe, zaradi česar ohranjajo status quo, ki ne bo doprinesel k transformaciji neenakih struktur, ki predpisujejo družbene in spolne vloge.\n',
				source: 'UNSD (2021), EIGE (2021).',
			},
			back: {
				title: 'HIBRIDNO DELO',
				body: 'angleški izraz: hybrid work\nkrajša definicija: Hibridno delo v praksi pomeni kombinacijo dela v prostorih delodajalca in dela od doma.\n',
				source: 'Prometej (2022).',
			},
		},
		{
			front: {
				title: 'DELO NA DOMU',
				body: 'angleški izraz: work from home, remote work\nkrajša definicija: Delo na domu označuje delo, ki ga delojemalci_ke po navodilih delodajalca opravljajo izključno izven prostorov delodajalca (običajno neposredno iz domače pisarne).\n',
				source: 'Prometej (2022).',
			},
			back: {
				title: 'PRAVICA DO ODKLOPA',
				body: 'angleški izraz: right to disconnect\nkrajša definicija: Pravica delojemalca_ke, da po delu ugasne svoje tehnološke naprave. To v praksi pomeni, da ne odgovarja na SMS sporočila, elektronsko pošto in na telefon.\n',
				source: 'ZRC SAZU (2022).',
			},
		},
		{
			front: {
				title: 'KRAJŠI DELOVNI ČAS',
				body: 'angleški izraz: short-time work\nkrajša definicija: Krajši delovni čas označuje obliko zaposlitve, kjer je tedenski obseg dela manjši od 40 ur. Pri tem gre bolj za to, da delodajalec_ka prilagodi delovne procese na način, da delojemalec_ka na tedenski ravni opravi manj kot 40 ur dela, pri čemer ne gre za klasično obliko krajšega delovnega časa z vidika prispevkov in neto izplačil delojemalca_ke.\n',
				source: 'Prometej (2022).',
			},
			back: {
				title: 'KORPORATIVNO PROSTOVOLJSTVO',
				body: 'angleški izraz: corporate volunteering\nkrajša definicija: Pri korporativnem prostovoljstvu gre za prostovoljsko neplačano delo zaposlenih za dobrobit širše skupnosti, ki ga z različnimi pobudami podpira delodajalec_ka oziroma podjetje.\n',
				source: 'Prostovoljstvo (2022).',
			},
		},
	]
		.map((x) => {
			if (x.front.title !== '') {
				return [x.front, x.back];
			}
			return [x.back];
		})
		.flat();

	const enPages: Page[] = [
		{
			front: { title: '', body: '', source: '' },
			back: {
				title: 'WORK-LIFE BALANCE',
				body: 'related terms: work-life balance, also reconciliation of work, family and private life\nshort definition: Work-life balance refers to the process of achieving balance not only with regard to household responsibilities, but also other responsibilities related to daily life.\ngeneral about coordinatination of professional and private life: Professional obligations should be flexible enough to allow workers of all biological and social genders to become part of lifelong learning and other activities that enable their professional and personal development. The key challenge of balancing professional and private life lies in career opportunities, lifelong learning and professional development activities, which are understood to be of secondary importance in promoting an equal share of responsibility between the sexes.\n',
				source: 'source: MOD (2007), EIGE (2021).',
			},
		},
		{
			front: {
				title: 'DOUBLE BURDEN',
				body: 'short definition: Double burden (sometimes also double shift or double day) denotes the work obligation of an individual who is employed and receives payment for this, but is also responsible for work that does not bring direct payment or another form of payment. It is usually either domestic or caring work.\n',
				source: 'source: De Ferranti (2004), Chesters (2012).',
			},
			back: {
				title: 'PARENTAL LEAVE',
				body: 'short definition: Parental leave refers to leave that can be taken by both mother and father. This starts immediately after the end of maternity leave and therefore belongs to both. In Slovenia, it lasts 260 days, of which each parent has the right to use 130. By agreement, the father can transfer the entire part of his parental leave to the mother, while the mother can transfer only 100 days of parental leave to the father (in this case, 30 days of parental leave remain, which they can be used by the mother or left unused).\n',
				source: 'source: Pravozavse (2022).',
			},
		},
		{
			front: {
				title: 'MATERNITY LEAVE',
				body: "short definition: Maternity leave is intended to prepare for childbirth, to care for and care for the child immediately after childbirth, and to protect the mother's health after it. Maternity leave lasts 105 days, of which the mother must use 14 days. Maternity leave is used as a full absence from work, and the mother can take maternity leave 28 days before the expected date of delivery, which is determined by the gynecologist.\n",
				source: 'source: Pravozavse (2022).',
			},
			back: {
				title: 'PATERNAL LEAVE',
				body: 'short definition: Paternity leave is intended for men with the goal of caring for the child. Paternity leave in Slovenia is not transferable to another person and lasts 30 days. This can be extended by 10 days in the case of the birth of twins and by 20 days in the case of triplets. Unlike maternity leave, paternity leave does not necessarily have to be fully consolidated, but can be used in two parts, whereby the first part must last at least 15 days in the period from the birth of the child to no later than one month after the end of the parental leave or allowance.\n',
				source: 'source: Pravozavse (2022).',
			},
		},
		{
			front: {
				title: 'AN ORGANIZATIONAL CULTURE BASED ON GENDER EQUALITY',
				body: 'short definition: An organizational culture based on gender equality means that the integrated and corporate system of values, norms, beliefs, attitudes and ways of implementing processes in the company is designed in a way that takes into account aspects of the principle of gender equality.\n',
				source: 'source: Ferland (2022).',
			},
			back: {
				title: 'STICKY FLOOR',
				body: 'short definition: A term used as a metaphor that highlights a discriminatory employment pattern that keeps workers, especially women, in lower career ranks or jobs with little mobility and invisible barriers to career advancement.\n',
				source: 'source: EIGE (2021).',
			},
		},
		{
			front: {
				title: 'UNPAID WORK',
				body: 'short definition: Work that creates goods and services but does not result in any direct payment or other form of payment; such work is e.g. housework or care work.\nGeneral about unpaid work: Unpaid work is unevenly distributed between women and men, so women have a higher rate of participation in this unpaid work.\n',
				source: 'source: EIGE (2021).',
			},
			back: {
				title: 'GENDER STEREOTYPES',
				body: 'short definition: Gender stereotypes are generalized characteristics, behaviors, abilities and interests defined only on the basis of gender; they are a reflection of the perception of men and women, the differences between them and their social roles. They create an unrealistic and unfair image of men and women. In real life, neither all men nor all women fit these descriptions.\n',
				source: 'source: Timeline (2018).',
			},
		},
		{
			front: {
				title: 'GENDER EQUALITY',
				body: "short definition: equal rights and duties for women, men, girls and boys\ngeneral about gender equality: Equality does not mean that men and women are equal, but rather that they have the same rights, duties and opportunities that do not depend on the biological sex they are born into. Gender equality means that both the interests, needs and priorities of men and women are accommodated in a way that recognizes the diversity of different groups of men and women. Equality between the sexes is not only a women's challenge, but the full commitment of men is necessary to achieve it. Equality between men and women is therefore understood as both a fundamental human right and a prerequisite, and above all an indicator of sustainable, people-centered development .\n",
				source: 'source: EIGE (2021), UN Women (2021).',
			},
			back: {
				title: 'GENDER EQUALITY/EQUITY',
				body: 'related term: de jure gender equality\nshort definition: An expression of fairness and legal order in the distribution of benefits and responsibilities between men and women.\ngeneral about gender equality: The concept of gender equality recognizes the different needs and power of men and women. What is important here is that the differences are identified and addressed in such a way that there is a legal reduction of the differences between the sexes. This includes either the principle of equal treatment or the implementation of policies that are tailored to a specific gender, but are treated as equivalent in terms of rights, benefits, responsibilities and opportunities. Despite the fact that the words equality and equality are two completely different terms, they are often used interchangeably. While international human rights treaties speak of equality, in certain sectors we speak of equality.',
				source: 'source: Desprez-Bouanchaud, Doolaege and Ruprecht (1999); EIGE (2021).',
			},
		},
		{
			front: {
				title: 'DIVISION OF DOMESTIC LABOUR',
				body: 'short definition: Providing care to those who are young, sick, elderly or less able, or otherwise deprived of the opportunity to care for themselves. The latter dictates that we define caring work as caring for those who are dependent on the care of a third party.\nSource: European Commission (1998), EIGE (2021).\nshort definition: Division of caring and household tasks between a man and a woman.\n',
				source: 'source: EIGE (EIGE, 2021)',
			},
			back: {
				title: 'EQUAL OPPORTUNITIES FOR MEN AND WOMEN',
				body: 'short definition: The absence of all barriers to economic, political and social participation based on biological or social sex.\ngeneral about equal opportunities for women and men: Obstacles to full participation are often indirect, difficult to measure and are maintained as part of a wider structure and social ideas. The principle of equal opportunities is one of the central goals of gender equality, which is based on the assumption of a wide range of strategies, measures and actions that are a prerequisite for addressing deep-rooted inequalities.\n',
				source: 'source: EIGE (2021).',
			},
		},
		{
			front: {
				title: 'EQUAL PAY FOR WORK OF EQUAL VALUE',
				body: 'short definition: Equal pay for work of equal value refers to the fact that a person is paid for work of equal value regardless of their biological or social sex, and under the conditions required by a particular job.\ngeneral about equal pay for work of equal value: Due to salary structures and the systematization of jobs, the system can be biased, since occupations where women are overrepresented in a relative sense are understood and systematized as jobs for a lower level of competence.\n',
				source: 'source: EIGE (2021).',
			},
			back: {
				title: 'THE GENDER PAY GAP',
				body: 'short definition: The gender pay gap refers to the difference in the share of earnings of one of the sexes, which is measured in relation to the average gross hourly rate of an employed man and woman.\ngeneral about the gender pay gap: Gross earnings are wages paid directly by the employer before taxes and social contributions. In the EU, the wage gap is officially understood as the "unadjusted gender pay gap", which does not include other factors that influence the wage gap, such as differences in education, experience on the labor market, number of hours worked, type work, etc.\n',
				source: 'source: European Commission (2014), EIGE (2021).',
			},
		},
		{
			front: {
				title: 'FAMILY OBLIGATIONS',
				body: 'short definition: Family obligations are understood as either care or support for a child or another family member who cannot independently perform daily duties and needs constant supervision or assistance.\ngeneral about family responsibilities: Women continue to shoulder a disproportionate share of the burden when it comes to raising a child or caring for other family members. This directly affects their employment or employment opportunities. Also, such obligations make it impossible for them to enter, participate or strengthen their own capacities in public, political or cultural life.\n',
				source: 'source: EIGE (2021).',
			},
			back: {
				title: 'GENDER MAINSTREAMING',
				body: 'short definition: Gender mainstreaming refers to the systematic inclusion of differences between the conditions, situations and needs of men and women in all aspects of public policies and actions.\ngeneral about gender mainstreaming: Gender mainstreaming is the (re)organization, improvement, development and evaluation of political processes in such a way that all gender perspectives are included in all public policies at all levels and levels by actors who are usually involved in the process of public policy making.\n',
				source: 'source: UNSD (2021), EIGE (2021).',
			},
		},
		{
			front: {
				title: 'GLASS CEILING',
				body: 'short definition: The glass ceiling indicates the occurrence of invisible obstacles that work against women and prevent them from occupying high decision-making positions in selected organizations, which can be of both public and private nature.\ngeneral about the glass ceiling: The term glass ceiling is used because it suggests the relative invisibility of an obstacle that maintains the status quo in a certain organization and prevents equal employment and career opportunities for men and women.\n',
				source: 'source: Boundless (2015), EIGE (2021).',
			},
			back: {
				title: 'INVISIBLE OBSTACLES',
				body: 'short definition: We understand invisible obstacles as attitudes and traditional assumptions, norms and values that prevent the emancipation of women and their full participation in society.\n',
				source: 'source: EIGE (2021).',
			},
		},
		{
			front: {
				title: 'GENDER NORMS',
				body: 'short definition: Gender norms are ideas about how women and men should behave. These ideas are internalized relatively early in childhood, and become part of the general life cycle of socialization and stereotyping.\n',
				source: 'source: UNSD (2021), EIGE (2021).',
			},
			back: {
				title: 'GENDER BLINDNESS',
				body: 'short definition: Gender blindness refers to the inability to recognize that the gender roles and obligations of men and women are predetermined and depend on a specific cultural, social, economic and political context.\ngeneral about gender blindness: Projects dealing with gender blindness do not take into account different roles and different needs, which is why they maintain the status quo, which will not contribute to the transformation of the unequal structures that prescribe social and gender roles.\n',
				source: 'source: UNSD (2021), EIGE (2021).',
			},
		},
		{
			front: {
				title: "WOMEN'S EMPOWERMENT",
				body: "short definition: We define women's empowerment as a process aimed at strengthening women's power and control over their own lives and strengthening their capacity to make strategic decisions for themselves.\ngeneral about women's empowerment: Women's empowerment should consist of five elements: i) a woman's sense of self-worth; ii) the right to make one's own choices; ii) the right to control one's own life, both in private and public life; iv) the ability to influence social changes that create a fairer social and economic framework, both nationally and internationally.\n",
				source: 'source: UN Commission on the Status of Women (2002), EIGE (2021).',
			},
			back: {
				title: 'OCCUPATIONAL GENDER SEGREGATION',
				body: 'short definition: The actual dominance of one gender in a certain profession, or a relatively high percentage of representation of one gender in the profession in relation to the expected share of representation of both sexes.\ngeneral about occupational segregation: There is an assumption in the world that women are relatively underrepresented in the aggregate in the working population, and their relative underrepresentation in all professions should also follow from this. The reality is quite different, as occupational segregation in relative terms can be problematic, as it explains why modern professions do not have 50% representation of both sexes. For this reason, female experts emphasize that in the case of occupational segregation, the assumption should be made that occupational segregation is a constitutive element of gender equality, given the absolute representation of both sexes in the chosen occupations.\n',
				source: 'source: EIGE (2021).',
			},
		},
		{
			front: {
				title: 'HYBRID WORK',
				body: "short definition: Hybrid work in practice means a combination of work at the employer's premises and work from home.\n",
				source: 'source: Prometheus (2022).',
			},
			back: {
				title: 'WORK AT HOME',
				body: "related terms: work from home, remote work\nshort definition: Work at home refers to work that employees perform exclusively outside the employer's premises (usually directly from the home office) according to the employer's instructions.\n",
				source: 'source: Prometheus (2022).',
			},
		},
		{
			front: {
				title: 'SLIDING WORKING HOURS',
				body: "short definition: Sliding working time refers to the employee's ability to decide when he/she will start the working day by himself/herself - in accordance with the previous agreement/organizational structure of the organization in which he/she is employed. In practice, this means that the employer allows the employee to come to work between, for example, 7-9 in the morning.\n",
				source: 'source: Prometheus (2022).',
			},
			back: {
				title: 'FLEXIBLE WORKING HOURS',
				body: 'Related terms: condensed workweeks, compressed work\nshort definition: Flexible working time refers to the possibility of the employee to determine the daily workload in terms of hours. This means that it is a flexible schedule that allows the employee to change his working day and work nine hours one day instead of seven hours on the selected other day of the week.\n',
				source: 'source: Prometheus (2022).',
			},
		},
		{
			front: {
				title: 'RIGHT TO DISCONNECT',
				body: 'short definition: The right of an employee to turn off their technological devices after work. In practice, this means that he does not respond to SMS messages, e-mails and telephone calls.\n',
				source: 'source: ZRC SAZU (2022).',
			},
			back: {
				title: 'SHORTER WORKING HOURS',
				body: "English term: short-time work\nshort definition: Part-time work refers to a form of employment where the weekly volume of work is less than 40 hours. This is more about the employer adjusting the work processes in such a way that the employee works less than 40 hours per week, and it is not a classic form of shorter working hours from the point of view of the employee's contributions and net payments.\n",
				source: 'source: Prometheus (2022).',
			},
		},
	]
		.map((x) => {
			if (x.front.title !== '') {
				return [x.front, x.back];
			}
			return [x.back];
		})
		.flat();

	return (
		<>
			<div className={'relative overflow-hidden'}>
				<div
					className={'w-full flex justify-center items-center -mb-2'}
				>
					{/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
					{/* @ts-ignore */}
					<BookyDooky>
						{(appstate.currentLanguage() === 'slSI'
							? sloPages
							: enPages
						).map((page, index) => {
							return (
								<div
									className={`page ${
										index % 2 === 0
											? 'bg-gradient-to-l rounded-l border-r-0'
											: 'bg-gradient-to-r rounded-r'
									} from-white to-gray-100 shadow border py-6 px-8 h-full`}
									key={`f${index}`}
								>
									{page.title && (
										<h1
											className={
												'text-lg mb-4 text-left font-bold rounded px-2.5 py-1 w-fit'
											}
											style={{
												background:
													'linear-gradient(45deg, #eed2c3, #c9aca0)',
												color: '#35384d',
												maxWidth:
													appstate.currentLanguage() ===
													'slSI'
														? '93%'
														: '100%',
											}}
										>
											{page.title}
										</h1>
									)}
									<div
										className={
											'text-sm flex flex-col gap-4 flex-1'
										}
									>
										{page.body
											.split('\n')
											.map((line, index) => {
												return (
													<div
														key={index}
														className={`${
															index === 0 &&
															'text-xs text-gray-900 italic'
														} ${
															window.innerWidth <
																1024 &&
															'text-xs'
														}`}
													>
														{line}
													</div>
												);
											})}
									</div>
									<div
										className={
											'text-xs text-gray-500 italic mt-2'
										}
									>
										{page.source &&
											(appstate.currentLanguage() ===
											'slSI'
												? 'Vir: '
												: '') + page.source}
									</div>
								</div>
							);
						})}
					</BookyDooky>
				</div>
				<div
					style={{
						width: '10rem',
					}}
					className="absolute right-2 bottom-2 flex  flex-col text-left space-y-4 align-end justify-end group"
				>
					<span className="hidden lg:flex opacity-30 group-hover:opacity-100 transition text-right flex-col items-end">
						<div className="text-xs pointer-events-none select-none">
							{getLocaledString(
								'Pritiskajte na spodnje ali zgornje robove strani',
								'Click on the bottom or top edges of the pages to turn them',
							)}
						</div>
						<div className={'transform scale-75'}>
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
								className={'transform rotate-180'}
							>
								<path
									d="M20.3284 11.0001V13.0001L7.50011 13.0001L10.7426 16.2426L9.32842 17.6568L3.67157 12L9.32842 6.34314L10.7426 7.75735L7.49988 11.0001L20.3284 11.0001Z"
									fill="currentColor"
								/>
							</svg>
						</div>
					</span>
				</div>
			</div>
		</>
	);
}
